import React from 'react';

import TableRow from './TableRow.jsx';

const TableBody = (props) => {
    let userListRowTableNodes;

    if (props.usuariosFiltrados != undefined && props.usuariosFiltrados != "") {
        userListRowTableNodes = props.usuariosFiltrados.map(row => {
            let estado;
            let isCurrentUser = false;

            if (row.Activo == true && row.Bloqueado == false && row.Bloqueado_Inactividad == false) {
                estado = 0;
            }
            if ((row.Activo == false && row.Bloqueado == true) || row.Bloqueado_Inactividad == true) {
                estado = 1
            }
            if (row.Activo == false && row.Bloqueado == false) {
                estado = 2
            }

            if (row.Id == props.currentUser)
                isCurrentUser = true;

            return (
                <TableRow ID={row.Id} nombre={row.Nombre} login={row.Login}
                    sucursal={row.SUCURSAL} sector={row.SECTOR}
                    estado={estado} isChecked={row.Seleccionado == true ? true : false} motivo={row.Bloqueado_Inactividad ? 'Usuario bloqueado por inactividad' : row.MotivoBloqueo}
                    bloqueadoPor={row.BloqueadoPor} fechaBloqueado={row.FechaBloqueo}
                    horaBloqueado={row.HoraBloqueo} eliminadoPor={row.EliminadoPor}
                    fechaEliminado={row.FechaEliminado} horaEliminado={row.HoraEliminado}
                    functions={props.functions} isCurrentUser={isCurrentUser}
                    setCheckbox={props.setCheckbox}
                    setUserState={props.setUserState}
                    perfilId={props.perfilId}
                    bloqueado_inactividad={row.Bloqueado_Inactividad}/>
            );
        });
    }

    return (
        <tbody>
            {userListRowTableNodes}
        </tbody>
    );
}

export default TableBody;